module.exports = __webpack_public_path__ + "static/media/sport-72.2efa8af8.jpg";